export enum ChartType {
	Bar = 'bar',
	Column = 'column',
	Pie = 'pie',
	Grid = 'grid',
	Scatter = 'scatter',
	EmptyColumnChart = 'emptyColumnChart',
	IndicatorColumnChart = 'indicatorColumnChart',
	Line = 'line',
	DoughnutChart = 'doughnutChart',
	Heatmap = 'heatmap',
	AreaSpline = 'areaspline',
	ProgressBar = 'progressBar'
}
